<template>
  <v-layout row wrap class="pl-3 pr-2">
    <confirmation-header-text text="Reciprocity Visa Duration detail" class="ml-2"
                              icon="mdi-alpha-b-box"></confirmation-header-text>

    <v-simple-table>
      <template v-slot:default>
        <thead>
        <tr>
          <th class="text-left">Visa Start Date</th>
          <th class="text-left">Visa End Date</th>
          <th class="text-left">Duration</th>
          <th class="text-left">Visa Fee (USD)</th>
          <th class="text-left">Type</th>
          <th class="text-left">Status</th>
          <th class="text-left">Action</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item,key) in reciprocity_visa_data.duration" :key="key">
          <td>{{ item.start_date }}</td>
          <td>{{ item.end_date }}</td>
          <td>{{ item.duration }}</td>
          <td>{{ item.visa_fee }}</td>
          <td>{{ item.type }}</td>
          <td>{{ item.status }}</td>
          <td>
            <v-btn @click="showEditDialog" small class="text-white ml-2" color="primary"
                   v-if="key !== 0 && item.status === 'Pending'"
            >
              Edit
            </v-btn>
            <v-btn small class="text-white ml-2" color="primary"
                   @click="showSpecialPaymentDialog(item.payment_ref,item.visa_fee)"
                   v-if="key !== 0 && item.status === 'Edited' && parseInt(item.visa_fee) !== 0"
            >
              Generate Voucher
            </v-btn>
            <v-btn small :loading="checkPaymentLoading" class="text-white ml-2" color="info" @click="checkPayment"
                   v-if="key !== 0 && item.status === 'Voucher Generated'"
            >
              <!--              {{visaRequest.traveller_id}}-->
              Check Payment
            </v-btn>
            <v-btn small class="text-white ml-2" color="info" @click="manualPaymentDialog = true" v-if="key !== 0 && item.status === 'Voucher Generated' && item.status !== 'Paid'"
            >
              <!--              {{visaRequest.traveller_id}}-->
              Pay Manually
            </v-btn>
            <v-btn small class="text-white ml-2" color="success" @click="approve" v-if="key !== 0 && item.status === 'Paid'"
            >
              <!--              {{visaRequest.traveller_id}}-->
              Approve
            </v-btn>
          </td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>

    <special-payment-dialog :payment-ref="payment_ref" :amount="visa_fee" :traveller-id="visaRequest.traveller.id"
                            @vouchergenerated="spcVoucherGenerated"/>

    <s-c-p-voucher-print-content v-if="showSCPVoucherContent" style="display: none"/>

    <manual-payment-dialog
        :url="'visa-requests/pay-reciprocity-visa-manually/'+$store.state.VisaRequestSingle.visaRequest.submission_no"
        @paid="loadData" v-model="manualPaymentDialog"/>


  </v-layout>
</template>

<script>
import ListItemDetail from "../../ListItemDetail";
import ConfirmationHeaderText from "../../ConfirmationHeaderText";
import SpecialPaymentDialog from "../../../components/dialogs/SpecialCasePaymentDialog";
import SCPVoucherPrintContent from "../../../components/dialogs/SCPVoucherPrintContent";
import {SET_PRINT_CONTENT} from "../../../store/mutation-type";
import {mapActions, mapGetters} from "vuex";
import ManualPaymentDialog from "@/components/dialogs/ManualPaymentDialog";

export default {
  data() {
    return {
      showSCPVoucherContent: false,
      payment_ref: null,
      visa_fee: null,
      manualPaymentDialog: false,
      approveModal:false
    }
  },
  computed: {
    reciprocity_visa_data() {
      return this.$store.state.VisaRequestSingle.visaRequest.extra.reciprocity_visa;
    },
    ...mapGetters("VisaRequestSingle", ["visaRequest", "checkPaymentLoading"]),
  },
  components: {
    ManualPaymentDialog,
    ListItemDetail,
    ConfirmationHeaderText,
    SpecialPaymentDialog,
    SCPVoucherPrintContent,
  },
  methods: {
    ...mapActions("VisaRequestSingle", ['getVisaRequestDetail',
      "checkReciprocityVisaPaymentStatus","approveReciprocityVisaRequest"]),
    ...mapActions("TravellerSingle", ["getHistory"]),
    showEditDialog() {
      this.$store.commit("VisaRequestSingle/setReciprocityDurationModal", true)
      this.$store.state.VisaRequestSingle.extended_reciprocity_visa = true;
    },
    showSpecialPaymentDialog(payment_ref, visa_fee) {
      this.payment_ref = payment_ref;
      this.visa_fee = visa_fee;
      this.$store.commit("TravellerSingle/setSpecialCasePaymentDialog", true);
    },
    spcVoucherGenerated() {
      this.getVisaRequestDetail(this.visaRequest.submission_no)
      this.showSCPVoucherContent = true;
      this.getHistory(this.visaRequest.traveller.id).then(() => {
        const content = document.getElementById('scp_voucher_print_content').innerHTML;
        this.$store.commit(SET_PRINT_CONTENT, content);
      });
    },
    checkPayment() {
      this.checkReciprocityVisaPaymentStatus().then(res => {
        this.$store.commit('Notification/showSuccess', 'Amount has been paid')
      }).catch(err => {
        this.$store.commit('Notification/showError', 'The amount is unpaid')
      });
      // try {
      //   await this.checkReciprocityVisaPaymentStatus();
      //   this.$store.commit('Notification/showSuccess', 'Amount has been paid')
      // } catch (e) {
      //   this.$store.commit('Notification/showError', 'The amount is unpaid')
      // }
    },
    async approve(){
      await this.$dialog.confirm({
        text: "Are you sure want to approve reciprocity visa ?",
        actions: {
          false: "No",
          true: {
            text: "Yes",
            handle: async () => {
              try {
                this.approveReciprocityVisaRequest()
                    .then(() => {
                      this.approveModal = false;
                      this.loading = false;
                      this.$store.commit("Notification/showSuccess", "Visa requested approved successfully");
                    })
                    .catch(error => {
                      this.loading = false;
                      this.$store.commit('Notification/showError', error.response.data.message)
                    });
              } catch (e) {
                this.approveModal = false;
                this.$store.commit('Notification/showError', error.response.data.message)
              }


            }
          }
        }
      });
    },
    loadData() {
      this.getVisaRequestDetail(this.visaRequest.submission_no)
    }
  }
};
</script>

<style>
</style>
